module.exports = __webpack_public_path__ + "img/63d0adf.jpg";